import { Box } from "@mui/material";
import Header from "./Header/Header";
import HeroSection from "./HeroSection/HeroSection";
import AboutSection from "./AboutSection/AboutSection";
import MenuPreview from "./MenuPreview/MenuPreview";
import LocationSection from "./LocationSection/LocationSection";
import ReviewsSection from "./ReviewsSection/ReviewsSection";
import FooterSection from "./FooterSection/FooterSection";

const LandingContainer = () => {
  return ( 
    <Box sx={{ minHeight: '100vh' }}>
      <Header page="landing"/>
      <Box component="main">
        <HeroSection />
        <AboutSection />
        <MenuPreview />
        <LocationSection />
        <ReviewsSection />
      </Box>
      <FooterSection page="landing" />
    </Box>
  );
};

export default LandingContainer;
